import { RegisterTeamMemberDto } from "../types/register-team-member.types";
import { ResponseData } from "./types";
import { httpClient } from "./common";
import { withApiErrorHandling } from "./withApiErrorHandling";

export class TeamMembersAPI {
  private static readonly API_URL = "/team_members";

  static async registerTeamMember(
    data: RegisterTeamMemberDto
  ): Promise<ResponseData<any>> {
    return withApiErrorHandling(async () => {
      return await httpClient.post(`${this.API_URL}/register`, data, true);
    }, "Error al registrar el miembro del equipo");
  }
  static async registerTeamMemberAdmin(
    data: RegisterTeamMemberDto,
    teamId: number,
    roleId: number
  ): Promise<ResponseData<any>> {
    return withApiErrorHandling(async () => {
      return await httpClient.post(
        `${this.API_URL}/admin/register`,
        {
          ...data,
          team_id: teamId,
          role_id: roleId,
        },
        true
      );
    }, "Error al registrar el miembro del equipo");
  }

  static async leaveTeam(): Promise<ResponseData<any>> {
    return withApiErrorHandling(async () => {
      return await httpClient.delete(this.API_URL, true);
    }, "Error al dejar el equipo");
  }

  static async updateTeamMember(
    memberId: number,
    data: any
  ): Promise<ResponseData<any>> {
    return withApiErrorHandling(async () => {
      return await httpClient.patch(`${this.API_URL}/${memberId}`, data, true);
    }, "Error al actualizar el miembro del equipo");
  }

  static async removeTeamMember(memberId: number): Promise<ResponseData<any>> {
    return withApiErrorHandling(async () => {
      return await httpClient.delete(`${this.API_URL}/${memberId}`, true);
    }, "Error al eliminar el miembro del equipo");
  }

  static async getAllTeamMembers(
    competitionId?: number
  ): Promise<ResponseData<any>> {
    return withApiErrorHandling(async () => {
      const url = competitionId
        ? `${this.API_URL}?competition_id=${competitionId}`
        : this.API_URL;
      return await httpClient.get(url, true);
    }, "Error al obtener los miembros del equipo");
  }
  static async getOneTeamMember(userId: number): Promise<ResponseData<any>> {
    return withApiErrorHandling(async () => {
      const response = await httpClient.get(`${this.API_URL}/${userId}`, true);
      return response;
    }, "Error al obtener el miembro del equipo");
  }
}
